import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA disabled. Instead of registering a self-destructing SW (which caused a
// reload loop on Chrome when the tab regained focus), we directly unregister any
// leftover app/kill-switch service worker. OneSignal's push worker is preserved.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        const scriptURL =
          (r.active || r.waiting || r.installing)?.scriptURL || '';
        // Kill only our own app/kill-switch SW. Never touch OneSignal's push worker.
        if (scriptURL.includes('/sw.js') && !scriptURL.includes('OneSignal')) {
          await r.unregister();
        }
      }
    } catch {/* ignore */}
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
